import { da } from "date-fns/locale";
import * as actionTypes from "../actionTypes";

export const getPaymentGateways = (data) => {
    return {
        type: actionTypes.GET_PAYMENT_GATEWAYS_START,
        payload: data,
    };
};
export const getPaymentGatewaysSuccess = (data) => {
    console.log("data in action of getPaymentGatewaysSuccess",data.data);
    return {
        type: actionTypes.GET_PAYMENT_GATEWAYS_SUCCESS,
        payload: data,
    };
};

export const getPaymentGatewaysFailure = (data) => {
    return {
        type: actionTypes.GET_PAYMENT_GATEWAYS_FAILURE,
        payload: data,
    };
};

export const messageHandler = () => {
    return {
        type: actionTypes.MESSAGE_HANDLER,
        payload: null,
    };
};